var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1.11628C4.69823 1.11628 1.61628 4.19823 1.61628 8C1.61628 11.8018 4.69823 14.8837 8.5 14.8837C12.3018 14.8837 15.3837 11.8018 15.3837 8C15.3837 4.19823 12.3018 1.11628 8.5 1.11628ZM0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8ZM5.87277 5.37277C6.09073 5.1548 6.44413 5.1548 6.66209 5.37277L8.49999 7.21066L10.3379 5.37277C10.5558 5.1548 10.9092 5.1548 11.1272 5.37277C11.3452 5.59073 11.3452 5.94413 11.1272 6.16209L9.28932 7.99999L11.1272 9.83788C11.3452 10.0558 11.3452 10.4092 11.1272 10.6272C10.9092 10.8452 10.5558 10.8452 10.3379 10.6272L8.49999 8.78932L6.66209 10.6272C6.44413 10.8452 6.09073 10.8452 5.87277 10.6272C5.6548 10.4092 5.6548 10.0558 5.87277 9.83788L7.71066 7.99999L5.87277 6.16209C5.6548 5.94413 5.6548 5.59073 5.87277 5.37277Z",
    fill: "#FF3030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcIcon);
export default __webpack_public_path__ + "static/media/xc-icon.46773027af9a4c6365f7949ef30dfbee.svg";
export { ForwardRef as ReactComponent };